import { allPageTypes } from "global/enums/allPageTypes"
import { gEnums } from "global/enums/globalEnums"
import { useContext, useMemo } from "react"
import { ParentContext } from "../ParentContext"
import { useAppUserAccess } from "./useAppUserAccess"
import { useStyles } from "./useStyles"

export const useAllowAppAdmin = ({ allows }) => {

  const { setStyleAndClass } = useStyles()

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}

  const appUserAccess = useAppUserAccess()
  const { accessLevel } = appUserAccess ?? {}

  const pageIcons = null

  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const defaultSnC = setStyleAndClass({ item: gEnums.projectStyles.gridIcons })

  const gcProps = { defaultSnC }

  // pageContext   
  const { appCredentialing, appNotifications, appMeetings, appQuestionsAndAnswers, appSurvey, appVoting } = aps_global ?? {}
  const { showNotificationsManagerOnHomeScreen, notificationsAuthLevel, allowNotifications } = appNotifications ?? {}
  const { credentialingHomeScreenCaption, showCredentialingManagerOnHomeScreen } = appCredentialing ?? {}
  const { allowMeetings, showMeetingsManagerOnHomeScreen, appAdminOnly } = appMeetings ?? {}
  const { allowSurvey, showSurveyManagerOnHomeScreen, surveyManagerAuthLevel } = appSurvey ?? {}
  const { allowQuestionsAndAnswers, showQandAManagerOnHomeScreen, qAndAHomeScreenCaption, questionsAndAnswersCollections } = appQuestionsAndAnswers ?? {}
  const { allowVoting, showVotingManagerOnHomeScreen, votingManagerAuthLevel, votingCollections } = appVoting ?? {}

  const {
    _allowVoting,
    _allowCredentialing,
    _allowMeetings,
    _allowSurvey,
    _allowQandA,
    _allowNotifications,
  } = useMemo(() => {
    const _a = {};

    const allowVtm =
      !pageIcons &&
      allowVoting &&
      showVotingManagerOnHomeScreen &&
      votingCollections;

    if (allowVtm && allows.avt && accessLevel >= votingManagerAuthLevel) {
      _a._allowVoting = true;
    }

    const allowCredentialing =
      !pageIcons && showCredentialingManagerOnHomeScreen;
    if (allowCredentialing && allows.avt) {
      _a._allowCredentialing = true;
    }

    const allowMtg =
      !pageIcons &&
      allowMeetings &&
      showMeetingsManagerOnHomeScreen;
    if (allowMtg && allows.avt && appAdminOnly) {
      _a._allowMeetings = true;
    }

    const allowSrv =
      !pageIcons &&
      allowSurvey &&
      showSurveyManagerOnHomeScreen;
    if (allowSrv && allows.avt && accessLevel >= surveyManagerAuthLevel) {
      _a._allowSurvey = true;
    }

    const allowQandA =
      !pageIcons &&
      allowQuestionsAndAnswers &&
      showQandAManagerOnHomeScreen &&
      questionsAndAnswersCollections;
    if (allowQandA && allows.aqa) {
      _a._allowQandA = true;
    }

    const allowNotes =
      !pageIcons &&
      allowNotifications
    if (allowNotes && allows.aao && accessLevel >= notificationsAuthLevel) {
      _a._allowNotifications = true;
    }

    return _a;
  }, [
    pageIcons,
    allowVoting,
    showVotingManagerOnHomeScreen,
    votingCollections,
    allows,
    accessLevel,
    votingManagerAuthLevel,
    showCredentialingManagerOnHomeScreen,
    allowMeetings,
    showMeetingsManagerOnHomeScreen,
    appAdminOnly,
    allowSurvey,
    showSurveyManagerOnHomeScreen,
    surveyManagerAuthLevel,
    allowQuestionsAndAnswers,
    showQandAManagerOnHomeScreen,
    questionsAndAnswersCollections,
    allowNotifications,
    showNotificationsManagerOnHomeScreen,
    notificationsAuthLevel,
  ]);

  const allowedItem = (viewItem, segProps, gcProps, hidden) => {
    const { key } = viewItem ?? {}
    return { viewItem, itemKey: key, segProps, gcProps, hidden }
  }

  const items = useMemo(() => {
    const _items = []
    if (!pageIcons) {
      if (_allowCredentialing) { _items.push(allowedItem({ key: allPageTypes.credentialScan }, { caption: credentialingHomeScreenCaption ? credentialingHomeScreenCaption : 'Credential Manager', icon: 'clipboard check', cn: 'ao' }, gcProps)) }
      if (_allowNotifications) { _items.push(allowedItem({ key: allPageTypes.notificationsManager }, { caption: 'Notifications Manager', icon: 'calendar check outline', cn: 'ao' }, gcProps)) }
      if (_allowMeetings) { _items.push(allowedItem({ key: allPageTypes.meetingsManager }, { caption: 'Meetings Manager', icon: 'clipboard check', cn: 'ao' }, gcProps)) }
      if (_allowQandA) { _items.push(allowedItem({ key: allPageTypes.qAndAManager }, { caption: qAndAHomeScreenCaption ? qAndAHomeScreenCaption : 'Q and A Manager', icon: 'clipboard check', cn: 'ao' }, gcProps)) }
      if (_allowSurvey) { _items.push(allowedItem({ key: allPageTypes.surveyManager }, { caption: 'Survey Manager', icon: 'clipboard check', cn: 'ao' }, gcProps)) }
      if (_allowVoting) { _items.push(allowedItem({ key: allPageTypes.votingManager }, { caption: 'Voting Manager', icon: 'clipboard check', cn: 'ao' }, gcProps)) }
    }
    return _items
  }, [_allowCredentialing, _allowNotifications, _allowMeetings, _allowQandA, _allowSurvey, _allowVoting])


  return items

}